import { InjectionToken } from '@angular/core';

export const ROOT_FORMS = new InjectionToken<any[]>('digitaix/core/forms: Root Forms');
export const FEATURE_FORMS = new InjectionToken<any[][]>(
  'digitaix/core/forms: Feature Forms'
);
export const BASE_GROUP_STATE_SELECTOR = new InjectionToken('digitaix/core/forms/BASE_FORM_ID', {
  providedIn: 'root',
  factory: () => null,
});
export const MOCK_FORM_STATE = new InjectionToken('digitaix/core/forms/MOCK_FORM_STATE', {
  providedIn: 'root',
  factory: () => null,
});
export const FORM_FIELD_APPEARANCE = new InjectionToken('digitaix/core/forms/FORM_FIELD_APPEARANCE', {
  providedIn: 'root',
  factory: () => 'legacy'
});
export const DX_FORM_ID = new InjectionToken('@digitaix/core/forms/DX_FORM_ID');
